/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `WorkosTeamMapping.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { WorkosTeamMapping } from "./WorkosTeamMapping";

import { Team } from "./Team";

export abstract class WorkosTeamMappingModel {
    id: number;
    createdAt: Dayjs;
    directorySyncId: string | null;
    organizationId: string;
    ssoConnectionId: string | null;
    teamId: number | null;
    updatedAt: Dayjs;
    team: Team | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        createdAt: Dayjs,
        directorySyncId: string | null,
        organizationId: string,
        ssoConnectionId: string | null,
        teamId: number | null,
        updatedAt: Dayjs,
        team: Team | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.directorySyncId = directorySyncId;
        this.organizationId = organizationId;
        this.ssoConnectionId = ssoConnectionId;
        this.teamId = teamId;
        this.updatedAt = updatedAt;
        this.team = team;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): WorkosTeamMapping {
        const newObject = new WorkosTeamMapping(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["directory_sync_id"],
            json["organization_id"],
            json["sso_connection_id"],
            json["team_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["team"] == null ? json["team"] : Team.fromApiObject(json["team"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(): any {
        return {
            id: this.id,
            created_at: this.createdAt,
            directory_sync_id: this.directorySyncId,
            organization_id: this.organizationId,
            sso_connection_id: this.ssoConnectionId,
            team_id: this.teamId,
            updated_at: this.updatedAt,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): WorkosTeamMapping {
        const clone = Object.create(this) as WorkosTeamMapping;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
